export default "<p>depositescheme works!</p>\n"